import type { ChapterPageContent } from "./textPanel/TextPanel";

export const CHAPTERS_CONTENT: Record<string, ChapterPageContent[]> = {
  '1-0': [
    {  x: -40, y: 270, width: 540, text: 'ch1_0' },
  ],
  '1-1': [
    {  x: 0, y: -400, width: 450, text: 'ch1_1_1' },
    {  x: 100, y: 100, width: 420, text: 'ch1_1_2' },
  ],
  '1-2': [
    {  x: 0, y: -350, width: 400, text: 'ch1_2_1' },
    {  x: 0, y: 350, width: 450, text: 'ch1_2_2' },
  ],
  '1-3': [
    {  x: -80, y: -450, width: 410, text: 'ch1_3_1' },
    {  x: -100, y: 270, width: 400, text: 'ch1_3_2' },
    {  x: 80, y: 440, width: 400, text: 'ch1_3_3' },
  ],
  '1-4': [
    {  x: -200, y: -400, width: 400, text: 'ch1_4' },
  ],
  '1-5': [
    {  x: 150, y: -300, width: 400, text: 'ch1_5' },
  ],
  '1-6': [
    {  x: -50, y: 350, width: 400, text: 'ch1_6' },
  ],


  '2-1': [
    {  x: -100, y: -450, width: 400, text: 'ch2_1_1' },
    {  x: 0, y: 0, width: 400, text: 'ch2_1_2' },
    {  x: -80, y: 370, width: 400, text: 'ch2_1_3' },
  ],
  '2-2': [
    {  x: 0, y: -450, width: 400, text: 'ch2_2_1' },
    {  x: 100, y: -350, width: 400, text: 'ch2_2_2' },
    {  x: 0, y: 0, width: 400, text: 'ch2_2_3' },
    {  x: -70, y: 380, width: 390, text: 'ch2_2_4' },
  ],
  '2-3': [
    {  x: 100, y: -420, width: 400, text: 'ch2_3_1' },
    {  x: -130, y: -340, width: 400, text: 'ch2_3_2' },
    {  x: 120, y: -220, width: 350, text: 'ch2_3_3' },
    {  x: 120, y: 200, width: 400, text: 'ch2_3_4' },
    {  x: -100, y: 400, width: 400, text: 'ch2_3_5' },
  ],
  '2-4': [
    {  x: 100, y: 200, width: 400, text: 'ch2_4' },
  ],
  '2-5': [
    {  x: 0, y: -150, width: 400, text: 'ch2_5' },
  ],
  '2-6': [
    {  x: -100, y: 140, width: 400, text: 'ch2_6' },
  ],


  '3-1': [
    {  x: 100, y: -200, width: 400, text: 'ch3_1' },
  ],
  '3-2': [
    {  x: 40, y: -450, width: 400, text: 'ch3_2_1' },
    {  x: 50, y: 0, width: 400, text: 'ch3_2_2' },
  ],
  '3-3': [
    {  x: -70, y: -400, width: 400, text: 'ch3_3_1' },
    {  x: -100, y: 300, width: 400, text: 'ch3_3_2' },
  ],
  '3-4': [
    {  x: 130, y: 100, width: 400, text: 'ch3_4_1' },
    {  x: 80, y: 230, width: 400, text: 'ch3_4_2' },
  ],
  '3-5': [
    {  x: 0, y: -300, width: 400, text: 'ch3_5_1' },
    {  x: 0, y: 360, width: 400, text: 'ch3_5_2' },
  ],
  '3-6': [
    {  x: 60, y: -370, width: 400, text: 'ch3_6_1' },
    {  x: -120, y: 440, width: 400, text: 'ch3_6_2' },
  ],
  '3-7': [
    {  x: 130, y: -400, width: 400, text: 'ch3_7_1' },
    {  x: -80, y: 430, width: 400, text: 'ch3_7_2' },
  ],


  '4-1': [
    {  x: 100, y: -150, width: 400, text: 'ch4_1_1' },
    {  x: -100, y: 100, width: 380, text: 'ch4_1_2' },
  ],
  '4-2': [
    {  x: -170, y: -400, width: 400, text: 'ch4_2_1' },
    {  x: 170, y: -360, width: 200, text: 'ch4_2_2' },
    {  x: -170, y: -260, width: 200, text: 'ch4_2_3' },
    {  x: 150, y: -200, width: 400, text: 'ch4_2_4' },
    {  x: 0, y: 0, width: 400, text: 'ch4_2_5' },
  ],
  '4-3': [
    {  x: -140, y: -450, width: 300, text: 'ch4_3_1' },
    {  x: 0, y: 0, width: 400, text: 'ch4_3_2' },
  ],
  '4-5': [
    {  x: 120, y: -420, width: 350, text: 'ch4_5_1' },
    {  x: -120, y: 420, width: 350, text: 'ch4_5_2' },
  ],
  '4-6': [
    {  x: 0, y: -400, width: 460, text: 'ch4_6' },
  ],

  "5-1": [
    {  x: -120, y: -400, width: 220, text: 'ch5_1_1' },
    {  x: -100, y: -100, width: 0, text: 'ch5_1_2' },
  ],
  '5-2': [
    {  x: 0, y: -400, width: 450, text: 'ch5_2_1' },
    {  x: -80, y: 250, width: 300, text: 'ch5_2_2' },
  ],
  '5-3': [
    {  x: 80, y: -450, width: 400, text: 'ch5_3_1' },
    {  x: 100, y: -300, width: 300, text: 'ch5_3_2' },
    {  x: 50, y: -160, width: 300, text: 'ch5_3_3' },
  ],
  '5-4': [
    {  x: -90, y: -430, width: 400, text: 'ch5_4_1' },
    {  x: 0, y: 170, width: 300, text: 'ch5_4_2' },
  ],
  '5-5': [
    {  x: 0, y: -430, width: 400, text: 'ch5_5_1' },
    {  x: -150, y: -300, width: 300, text: 'ch5_5_2' },
    {  x: 150, y: -250, width: 260, text: 'ch5_5_3' },
    {  x: -130, y: -180, width: 200, text: 'ch5_5_4' },
    {  x: 150, y: 400, width: 300, text: 'ch5_5_5' },

  ],
  '5-6': [
    {  x: 0, y: -380, width: 500, text: 'ch5_6_1' },
  ],

  "6-1": [
    {  x: -30, y: -420, width: 450, text: 'ch6_1_1' },
    {  x: 130, y: -140, width: 150, text: 'ch6_1_2' },
    {  x: 150, y: 100, width: 150, text: 'ch6_1_3' },
    {  x: 0, y: 420, width: 0, text: 'ch6_1_4' },
  ],
  '6-2': [
    {  x: -60, y: -220, width: 450, text: 'ch6_2_1' },
    {  x: 160, y: 190, width: 0, text: 'ch6_2_2' },
  ],
  '6-3': [
    {  x: 100, y: -350, width: 0, text: 'ch6_3_1' },
  ],
  '6-4': [
    {  x: -100, y: -200, width: 250, text: 'ch6_4_1' },
  ],
  '6-5': [
    {  x: 150, y: -350, width: 200, text: 'ch6_5_1' },
  ],
  '6-6': [
    {  x: -100, y: -300, width: 340, text: 'ch6_6_1' },
  ],
};